import React from 'react';
import './tag.scss';

export default function Tag(props) {
  const { text, ...restProps } = props;
  return (
    <span className="lf-tag" {...restProps}>{ text }</span>
  );
}
